import { Moment } from 'moment';
import I18n from 'I18n';

import { CalendarViewType } from 'framework-listing-lib/types';

function typedToLowercase<T extends string>(str: T) {
  return str.toLowerCase() as Lowercase<T>;
}

export function getNextPeriodDate({
  date,
  period,
}: {
  date: Moment;
  period: CalendarViewType;
}) {
  return date
    .clone()
    .add(1, typedToLowercase(period))
    .startOf(typedToLowercase(period));
}

export function getPreviousPeriodDate({
  date,
  period,
}: {
  date: Moment;
  period: CalendarViewType;
}) {
  return date
    .clone()
    .subtract(1, typedToLowercase(period))
    .startOf(typedToLowercase(period));
}

/**
 * Facade for converting timestamps into Moments
 * Use this instead of calling I18n.moment directly so that we can
 * more safely upgrade all dates to portalTz, mock moment for tests, etc
 * @param displayTimestamp milliseconds from epoch
 * @returns A Moment object
 */
export function getCalendarMomentFromTimestamp(displayTimestamp: number) {
  return I18n.moment(displayTimestamp);
}
